import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { RequestsList } from './components/RequestsList';
import { RequestDto } from './dtos/RequestDto';
import { RequestInfo } from './components/RequestInfo';
import { getRequests } from './services/requests.service';
import './App.less';

const { Header, Sider } = Layout;

const nav = [{key: 'requests', label: 'Requests'}]

const App: React.FC = () => {
    const [data, setData] = useState<RequestDto[]>([]);
    const [currentRequest, setCurrentRequest] = useState<RequestDto>();

    useEffect(() => {
        getRequests().then((items) => {
            setData(items);
            if (items.length > 0) {
                setCurrentRequest(items[0]);
            }
        });

        const apiUrl = process.env.REACT_APP_API_URL || '';
        const sse = new EventSource(`${apiUrl}/sse`);

        sse.addEventListener("message", function(e) {
            try {
                const parsed = JSON.parse(e.data)
                if (parsed) {
                    setData(data => [parsed, ...data])
                }
            } catch (e) {}
        })

        return () => {
            sse.close();
        };
    }, [])

    return (
        <Layout hasSider>
            <Sider width={350} className="site-layout-background"
                   style={{
                       overflow: 'auto',
                       height: '100vh',
                       position: 'fixed',
                       left: 0,
                       top: 0,
                       bottom: 0,
                   }}
            >
                <div className="logo">Catch me!</div>
                <RequestsList data={data} onItemClick={setCurrentRequest} />
            </Sider>
            <Layout className="site-layout" style={{marginLeft: 350}}>
                <Header className="site-layout-background" style={{padding: 0}}>
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={[nav[0].key]} items={nav}/>
                </Header>
                { currentRequest && <RequestInfo data={currentRequest} /> }
            </Layout>
        </Layout>
    );
}

export default App;